import ChangePriceTypeModal from "components/Common/Modal/Bill/ChangePriceType/ChangePriceTypeModal";
import { ModalsStateContext, ModalsDispatchContext } from "./BillModal.context";
import BillStatementModal from "components/Common/Modal/Bill/BillStatement/BillStatement";
import ReSubscribeModal from "components/Common/Modal/Bill/ResumeSubscription/ResumeSubscription";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { useModal } from "src/hooks/useModal";
import { payPlan } from "src/config/priceTypeList";
import ChangePayTermModal from "components/Common/Modal/Bill/ChangePayTerm/ChangePayTermModal";
import ChangeLicenseCountModal from "components/Common/Modal/Bill/ChangeLicenseCount/ChangeLicenseCountModal";
import SubscriptionsCancelModal from "components/Common/Modal/Bill/SubscriptionsCancel/SubscriptionsCancelModal";

interface IModalProvider {
  children: React.ReactNode;
}
const BillModalsProvider = ({ children }: IModalProvider) => {
  const {
    payInfoModalState,
    showBillStatement,
    setShowBillStatement,
    cancelButton,
  } = useBillStatement();
  const { isResumeSubscription } = useModal();
  const dispatch = {};
  const state = {};
  return (
    <ModalsDispatchContext.Provider value={dispatch}>
      <ModalsStateContext.Provider value={state}>
        {children}
        {showBillStatement && (
          <BillStatementModal
            showBillStatement={showBillStatement}
            cancelButton={cancelButton}
            // billHistory={billHistory}
            // goPrint={goPrint}
          />
        )}
        {/* 구독 재개하기 모달 */}
        {isResumeSubscription && <ReSubscribeModal />}
        {/* 요금제 변경 모달 - toggleModalConfirmPrice*/}
        {payInfoModalState?.priceType && (
          <ChangePriceTypeModal
            modal={payInfoModalState}
            toggleModalConfirmPrice={() => {}}
            priceType={"basic"}
            changePriceType={""}
            handleChange={() => {}}
            serviceList={[]}
            payPlanInfo={payPlan}
            // 요금제 정보
            driveUserPerPriceYear={0}
            driveUserPerPrice={0}
            basicUserPerPriceYear={0}
            basicUserPerPrice={0}
            basicPlusUserPerPrice={0}
            plusUserPerPriceYear={0}
            plusUserPerPrice={0}
            plusPlusUserPerPrice={0}
            isCheckPromotionCode={""}
            payTerm={"month"}
            licenseCount={0}
            changeLicenseCount={() => {}}
            changePrice={() => {}}
            changeNextPayDate={""}
            payCompany={"wrapsody"}
            changePriceIncTax={0}
            confirmPrice={() => {}}
            toggleModalCheckConfirmPrice={() => {}}
            promotionCode={""}
            promotionApply={() => {}}
          />
        )}
        {/* 사용자 수 변경 모달 */}
        {payInfoModalState?.licenseCount && (
          <ChangeLicenseCountModal
            changePayTerm={() => {}}
            checkConfirmPayTerm={() => {}}
            serviceList={[]}
            toggleModalConfirmPayTerm={() => {}}
            modal
            payTerm={"month"}
            payCompany={"INICIS"}
            handleChange={() => {}}
            changePrice
            changeNextPayDate
            changePriceIncTax
            confirmPrice={() => {}}
          />
        )}
        {/* 결제 주기 변경 모달 */}
        {payInfoModalState?.payTerm && (
          <ChangePayTermModal
            modal={payInfoModalState}
            priceType={"basic"}
            handleChange={() => {}}
            serviceList={[]}
            // 요금제 정보 정리 필요!
            driveUserPerPrice={0}
            basicUserPerPriceYear={0}
            basicUserPerPrice={0}
            basicPlusUserPerPrice={0}
            plusPlusUserPerPrice={0}
            plusUserPerPriceYear={0}
            plusUserPerPrice={0}
            changePrice={() => {}}
            changeNextPayDate={() => {}}
            changePriceIncTax={0}
            confirmPrice={() => {}}
            toggleModalConfirmPayTerm={() => {}}
            changePayTerm={""}
            // currency={currency}
            checkConfirmPayTerm={() => {}}
          />
        )}
        {/* 정기결제 해지 모달 */}
        {payInfoModalState?.subscriptionsCancel && <SubscriptionsCancelModal />}
        {/* 청구서 버튼 */}
        {showBillStatement && (
          <BillStatementModal
            showBillStatement={showBillStatement}
            cancelButton={() => setShowBillStatement(false)}
          />
        )}
      </ModalsStateContext.Provider>
    </ModalsDispatchContext.Provider>
  );
};

export default BillModalsProvider;
